/**
 * @generated SignedSource<<4a14f4e29d93bd9bd20aabfe3e907227>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type JobEventStackNotification_event$data = {
  readonly message?: string | null;
  readonly timestamp: any;
  readonly uuid: string;
  readonly " $fragmentType": "JobEventStackNotification_event";
};
export type JobEventStackNotification_event$key = {
  readonly " $data"?: JobEventStackNotification_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"JobEventStackNotification_event">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobEventStackNotification_event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uuid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timestamp",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "message",
          "storageKey": null
        }
      ],
      "type": "JobEventStackNotification",
      "abstractKey": null
    }
  ],
  "type": "JobEvent",
  "abstractKey": "__isJobEvent"
};

(node as any).hash = "e62ff000452d31a7e06c2a0262e0732b";

export default node;
